import confetti from 'canvas-confetti';

/**
 * 기본 Confetti (축하)
 */
export const fireConfetti = () => {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8'],
  });
};

/**
 * 양쪽에서 폭죽 (당첨)
 */
export const fireConfettiSides = () => {
  const duration = 3 * 1000;
  const animationEnd = Date.now() + duration;
  const defaults = { 
    startVelocity: 30, 
    spread: 360, 
    ticks: 60, 
    zIndex: 0,
    colors: ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F'],
  };

  function randomInRange(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  const interval: any = setInterval(function() {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    const particleCount = 50 * (timeLeft / duration);

    // 왼쪽에서
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
    });
    // 오른쪽에서
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
    });
  }, 250);
};

/**
 * 하트 폭죽 (특별한 당첨)
 */
export const fireHeartConfetti = () => {
  const scalar = 2;
  const heart = confetti.shapeFromText({ text: '🧡', scalar });

  confetti({
    shapes: [heart],
    particleCount: 50,
    spread: 100,
    origin: { y: 0.6 },
    scalar,
  });
};

/**
 * 돈까스 폭죽 (로또 당첨)
 */
export const fireDonkatsuConfetti = () => {
  const scalar = 3;
  const donkatsu = confetti.shapeFromText({ text: '🍖', scalar });

  // 연속 3번
  const defaults = {
    shapes: [donkatsu],
    scalar,
    spread: 360,
    ticks: 100,
    gravity: 0.5,
    decay: 0.94,
    startVelocity: 30,
  };

  confetti({
    ...defaults,
    particleCount: 30,
    origin: { x: 0.3, y: 0.5 },
  });

  setTimeout(() => {
    confetti({
      ...defaults,
      particleCount: 30,
      origin: { x: 0.5, y: 0.3 },
    });
  }, 200);

  setTimeout(() => {
    confetti({
      ...defaults,
      particleCount: 30,
      origin: { x: 0.7, y: 0.5 },
    });
  }, 400);
};

/**
 * 폭죽 비 (화려하게)
 */
export const fireConfettiRain = () => {
  const duration = 2 * 1000;
  const animationEnd = Date.now() + duration;

  (function frame() {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: ['#FF6B6B', '#4ECDC4', '#45B7D1'],
    });
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: ['#FFA07A', '#98D8C8', '#F7DC6F'],
    });

    if (Date.now() < animationEnd) {
      requestAnimationFrame(frame);
    }
  }());
};
